import pageContentRoutes from './pageContent.routes';

import pageContentSaveController from './controllers/pageContent.save.controller';
import pageContentFormController from './controllers/pageContent.form.controller';
import pageContentListController from './controllers/pageContent.list.controller';

import pageContentHomeController from './controllers/pageContent.home.controller';
import pageContentSpadaysController from './controllers/pageContent.spadays.controller';
import pageContentGenericController from './controllers/pageContent.generic.controller';

import pageContentSaveComponent from './components/pageContent.save.component';
import pageContentFormComponent from './components/pageContent.form.component';
import pageContentListComponent from './components/pageContent.list.component';

import pageContentHomeComponent from './components/pageContent.home.component';
import pageContentTreatmentsComponent from './components/pageContent.treatments.component';
import pageContentSpadaysComponent from './components/pageContent.spadays.component';
import pageContentHeroTextComponent from './components/pageContent.heroText.component';
import pageContentSingleText from './components/pageContent.singleText.component';
import pageContentConfirmationComponent from './components/pageContent.confirmation.component';
import pageContentCheckoutComponent from './components/pageContent.checkout.component';
import pageContentEmailComponent from './components/pageContent.email.component';

import pageContentService from './services/pageContent.service';
import pageContentTransformer from './services/pageContent.transformer.service';

let pageContentModule = angular.module('spabooker.pageContent', [  ])
  .config(pageContentRoutes)

  .controller('pageContentSaveController', pageContentSaveController)
  .controller('pageContentFormController', pageContentFormController)
  .controller('pageContentListController', pageContentListController)

  .controller('pageContentHomeController', pageContentHomeController)
  .controller('pageContentSpadaysController', pageContentSpadaysController)
  .controller('pageContentGenericController', pageContentGenericController)

  .component('pageContentSave', pageContentSaveComponent)
  .component('pageContentForm', pageContentFormComponent)
  .component('pageContentList', pageContentListComponent)

  .component('pageContentHome', pageContentHomeComponent)
  .component('pageContentTreatments', pageContentTreatmentsComponent)
  .component('pageContentSpadays', pageContentSpadaysComponent)
  .component('pageContentSingleText', pageContentSingleText)
  .component('pageContentConfirmation', pageContentConfirmationComponent)
  .component('pageContentCheckout', pageContentCheckoutComponent)
  .component('pageContentEmail', pageContentEmailComponent)
  .component('pageContentHeroText', pageContentHeroTextComponent)

  .factory('pageContentService', pageContentService)
  .factory('pageContentTransformer', pageContentTransformer)
;

export default pageContentModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/index.js